<template lang="html">
<div class="subpage addrule_edit">
    <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="true" label-position="right" label-width="120px">
        <!-- 负责人 -->
        <el-form-item label="性别">
            <el-switch v-model="params.sex" :active-value="2" :inactive-value="1" active-text="女" inactive-text="男">>
            </el-switch>
        </el-form-item>
        <!-- 成员 -->
        <el-form-item label="咨询电话" prop="cellphone">
            <el-input size="medium" class="inpText" v-model="params.cellphone" placeholder="请输入咨询电话"></el-input>
        </el-form-item>
        <el-form-item label="专业领域" prop="majorId">
            <all-select code="zyly" v-model="params.majorId" paramsKey="major" @change="zylySelectChange" plaText="专业领域" />
        </el-form-item>
        <el-form-item label="执业律所">
            <el-input size="medium" v-model="params.firm" placeholder="请输入执业律所"></el-input>
        </el-form-item>
        <el-form-item label="职务">
            <el-input size="medium" v-model="params.post" placeholder="请输入职务"></el-input>
        </el-form-item>
        <el-form-item label="执业证号">
            <el-input size="medium" v-model="params.certificateNo" placeholder="请输入执业证号"></el-input>
        </el-form-item>
        <el-form-item label="简介" prop="summary">
            <el-input size="medium" style="width:750px;" type="textarea" v-model="params.summary" placeholder="请输入简介"></el-input>
        </el-form-item>
        <el-form-item label="个人介绍" prop="introduce">
            <text-editor class="editor" style="width:750px;" ref="textEditor" v-model="params.introduce" />
        </el-form-item>
    </el-form>

</div>
</template>

<script>
import {
    getLawyerListByCondition,

} from '@/api/jingshi';

export default {
    props: ['indata'],
    data() {
        return {
            dialogFzrVisible: false,
            loading: false,
            options: [],
            searchValue: '',
            // formLabelWidth:'20',
            params: {
                sex: 2, //性别 1男 2女
                cellphone: '', //咨询电话
                majorId: '', //专业领域
                major: '',
                firm: '', //职业律所
                post: '', //职务
                certificateNo: '', //职业证号
                summary: '', //简介
                introduce: '', //个人介绍
            },
            formFzr: {
                lawyerName: '',
                lawyerPost: '',
                lawyerId: '',
            },
            rules: {
                cellphone: [{
                    required: true,
                    message: '咨询电话不能为空',
                    trigger: 'blur'
                }],
                majorId: [{
                    required: true,
                    message: '专业领域不能为空',
                    trigger: 'blur'
                }],
                summary: [{
                    required: true,
                    message: '简介不能为空',
                    trigger: 'blur'
                }],
                introduce: [{
                    required: true,
                    message: '个人介绍不能为空',
                    trigger: 'blur'
                }],
            }
        }
    },
    watch: {
        indata: function (e) {
            if (e) {
                for (let key in this.params) {
                    if (e.hasOwnProperty(key)) {
                        this.params[key] = e[key];
                    }
                }
            }
        }
    },
    methods: {
        remoteMethod(query) {
            if (query !== '') {
                this.loading = true;
                var param = {
                    status: 1,
                    name: query,
                    basePage: {
                        size: 100,
                        no: 1
                    }
                }
                getLawyerListByCondition(param).then(res => {
                    console.log(res);
                    this.loading = false;
                });
            } else {
                this.options = [];
            }
        },
        delMember(row) {

        },
        delFzr(row) {
            console.log(row);
            for (var i = 0; i < this.params.fuzerenList.length; i++) {
                if (this.params.fuzerenList[i].id === row.id) {
                    this.params.fuzerenList.splice(i, 1);
                }
            }
            console.log(this.params.fuzerenList);
        },
        addFzr() {
            var user = {
                lawyerName: this.formFzr.lawyerName,
                lawyerPost: this.formFzr.lawyerPost,
                lawyerId: this.formFzr.lawyerId,
            }
            this.params.fuzerenList.push(user);

            this.dialogFzrVisible = false;

        },
        zylySelectChange(e) {
            console.log(e);
            this.params.major = e.name;
        },
        openFzr() {
            this.formFzr = {
                lawyerName: '',
                lawyerPost: '',
                lawyerId: '',
            };
            this.dialogFzrVisible = true;
        },
        saveReturn: function () {
            var vues = this;
            return new Promise((reslove, reject) => {
                console.log(vues.params);
                // vues.params.introduce = this.$refs.textEditor.editorContent;
                vues.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        reslove(vues.params);
                    } else {
                        reslove(false);
                    }
                })
            })
        }
    },

    created: function () {
        var vues = this;
        if (this.indata) {
            for (let key in this.params) {
                if (this.indata.hasOwnProperty(key)) {
                    this.params[key] = this.indata[key];
                }
            }
            console.log(this.params);
        }
    }
}
</script>

<style lang="scss" scoped>
// .el-form-item.is-error .el-form-item__content .editor {
//     border-color: red!important;
// }
</style>

<style lang="css">
.subpage.addrule_edit .el-input__inner {
    border-radius: 0px !important;
}

.subpage.addrule_edit .selects {
    width: 240px !important;
}

.subpage.addrule_edit .el-input {
    width: 240px !important;
}
</style>



// WEBPACK FOOTER //
// subpage2.vue?3d2fea40